var map = {
	"./ABW.svg": "a467",
	"./AFG.svg": "c937",
	"./AGO.svg": "06d8",
	"./AIA.svg": "3e47",
	"./ALA.svg": "c2c6",
	"./ALB.svg": "f1b4",
	"./AND.svg": "c4ee",
	"./ANT.svg": "c810",
	"./ARE.svg": "09db",
	"./ARG.svg": "fb41",
	"./ARM.svg": "fcc1",
	"./ASM.svg": "2aa3",
	"./ATA.svg": "a6be",
	"./ATF.svg": "7ea0",
	"./ATG.svg": "b0ab",
	"./AUS.svg": "095f",
	"./AUT.svg": "d004",
	"./AZE.svg": "196c",
	"./BDI.svg": "a174",
	"./BEL.svg": "e18f",
	"./BEN.svg": "f874",
	"./BES.svg": "7dfd",
	"./BFA.svg": "9f6d",
	"./BGD.svg": "54c9",
	"./BGR.svg": "e802",
	"./BHR.svg": "3250",
	"./BHS.svg": "9081",
	"./BIH.svg": "1a70",
	"./BLM.svg": "3a68",
	"./BLR.svg": "eeb0",
	"./BLZ.svg": "4099",
	"./BMU.svg": "0705",
	"./BOL.svg": "4ee9",
	"./BRA.svg": "baff",
	"./BRB.svg": "46ee",
	"./BRN.svg": "9845",
	"./BTN.svg": "bbe5",
	"./BVT.svg": "bcd7",
	"./BWA.svg": "0c50",
	"./CAF.svg": "25fb",
	"./CAN.svg": "1fe1",
	"./CCK.svg": "db6e",
	"./CHE.svg": "4ad9",
	"./CHL.svg": "706c",
	"./CHN.svg": "1e49",
	"./CIV.svg": "deec",
	"./CMR.svg": "f2e9",
	"./COD.svg": "9231",
	"./COG.svg": "fcbb",
	"./COK.svg": "2fb1",
	"./COL.svg": "209f",
	"./COM.svg": "4517",
	"./CPV.svg": "174d",
	"./CRI.svg": "1081",
	"./CUB.svg": "1781",
	"./CUW.svg": "865b",
	"./CXR.svg": "6f7e",
	"./CYM.svg": "cc9e",
	"./CYP.svg": "f970",
	"./CZE.svg": "7c2f",
	"./DEU.svg": "d5c7",
	"./DJI.svg": "c0f4",
	"./DMA.svg": "6f89",
	"./DNK.svg": "3d0a",
	"./DOM.svg": "4739",
	"./DZA.svg": "67cd",
	"./ECU.svg": "7adc",
	"./EGY.svg": "632a",
	"./ERI.svg": "88f8",
	"./ESH.svg": "f321",
	"./ESP.svg": "2381",
	"./EST.svg": "2c16",
	"./ETH.svg": "0cc1",
	"./FIN.svg": "cba5",
	"./FJI.svg": "df53",
	"./FLK.svg": "6a09",
	"./FRA.svg": "600f",
	"./FRO.svg": "e87d",
	"./FSM.svg": "3a4b",
	"./GAB.svg": "a907",
	"./GBR.svg": "7fc4",
	"./GEO.svg": "282b",
	"./GGY.svg": "e2ab",
	"./GHA.svg": "7076",
	"./GIB.svg": "20a2",
	"./GIN.svg": "c301",
	"./GLP.svg": "3aa3",
	"./GMB.svg": "4334",
	"./GNB.svg": "36a9",
	"./GNQ.svg": "05bf",
	"./GRC.svg": "9257",
	"./GRD.svg": "4314",
	"./GRL.svg": "9ffa",
	"./GTM.svg": "141a",
	"./GUF.svg": "1392",
	"./GUM.svg": "f09d",
	"./GUY.svg": "ff95",
	"./HKG.svg": "470b",
	"./HMD.svg": "ec97",
	"./HND.svg": "f31c",
	"./HRV.svg": "ba7d",
	"./HTI.svg": "89fb",
	"./HUN.svg": "3f2b",
	"./IDN.svg": "e155",
	"./IMN.svg": "ee3a",
	"./IND.svg": "a7d4",
	"./IOT.svg": "c93f",
	"./IRL.svg": "852a",
	"./IRN.svg": "a13b",
	"./IRQ.svg": "5395",
	"./ISL.svg": "55af",
	"./ISR.svg": "40bd",
	"./ITA.svg": "9d97",
	"./JAM.svg": "fc72",
	"./JEY.svg": "c1aa",
	"./JOR.svg": "9a2a",
	"./JPN.svg": "ad24",
	"./KAZ.svg": "6435",
	"./KEN.svg": "69e1",
	"./KGZ.svg": "55a8",
	"./KHM.svg": "c846",
	"./KIR.svg": "959f",
	"./KNA.svg": "2aae",
	"./KOR.svg": "1b07",
	"./KWT.svg": "4152",
	"./LAO.svg": "0681",
	"./LBN.svg": "de50",
	"./LBR.svg": "c079",
	"./LBY.svg": "b54f",
	"./LCA.svg": "29c1",
	"./LIE.svg": "3366",
	"./LKA.svg": "8663",
	"./LSO.svg": "9fc5",
	"./LTU.svg": "326e",
	"./LUX.svg": "4f12",
	"./LVA.svg": "471f",
	"./MAC.svg": "96c0",
	"./MAF.svg": "1757",
	"./MAR.svg": "7d17",
	"./MCO.svg": "0422",
	"./MDA.svg": "e9fd",
	"./MDG.svg": "8abe",
	"./MDV.svg": "af31",
	"./MEX.svg": "e274",
	"./MHL.svg": "a5e3",
	"./MKD.svg": "f8d2",
	"./MLI.svg": "6747",
	"./MLT.svg": "b188",
	"./MMR.svg": "b72e",
	"./MNE.svg": "4344",
	"./MNG.svg": "83d2",
	"./MNP.svg": "a140",
	"./MOZ.svg": "f478",
	"./MRT.svg": "c11f",
	"./MSR.svg": "8619",
	"./MTQ.svg": "59c0",
	"./MUS.svg": "d839",
	"./MWI.svg": "7225",
	"./MYS.svg": "93e9",
	"./MYT.svg": "be8c",
	"./NAM.svg": "8886",
	"./NCL.svg": "33ed",
	"./NER.svg": "834a",
	"./NFK.svg": "f282",
	"./NGA.svg": "35a2",
	"./NIC.svg": "82b9",
	"./NIU.svg": "66dd",
	"./NLD.svg": "ab5a",
	"./NOR.svg": "9050",
	"./NPL.svg": "1a74",
	"./NRU.svg": "f1b6",
	"./NZL.svg": "8046",
	"./OMN.svg": "f671",
	"./PAK.svg": "b8ff",
	"./PAN.svg": "1e1d",
	"./PCN.svg": "265a",
	"./PER.svg": "a1ce",
	"./PHL.svg": "46c9",
	"./PLW.svg": "2d16",
	"./PNG.svg": "eb49",
	"./POL.svg": "d445",
	"./PRI.svg": "3c6a",
	"./PRK.svg": "bf5a",
	"./PRT.svg": "0004",
	"./PRY.svg": "5fbc",
	"./PSE.svg": "e074",
	"./PYF.svg": "be1e",
	"./QAT.svg": "b74e",
	"./REU.svg": "0b96",
	"./ROU.svg": "f3f7",
	"./RUS.svg": "b39b",
	"./RWA.svg": "63a3",
	"./SAU.svg": "34e5",
	"./SCG.svg": "d23c",
	"./SDN.svg": "9b87",
	"./SEN.svg": "ff8c",
	"./SGP.svg": "f419",
	"./SGS.svg": "2c27",
	"./SHN.svg": "f23d",
	"./SJM.svg": "d164",
	"./SLB.svg": "c6a2",
	"./SLE.svg": "0752",
	"./SLV.svg": "4c35",
	"./SMR.svg": "900c",
	"./SOM.svg": "485cb",
	"./SPM.svg": "ffeb",
	"./SRB.svg": "b56a",
	"./SSD.svg": "04b8",
	"./STP.svg": "1886",
	"./SUR.svg": "ae12",
	"./SVK.svg": "9901",
	"./SVN.svg": "5952",
	"./SWE.svg": "d253",
	"./SWZ.svg": "2f4d",
	"./SXM.svg": "a9d6",
	"./SYC.svg": "4568",
	"./SYR.svg": "1e81",
	"./TCA.svg": "6001",
	"./TCD.svg": "1c92",
	"./TGO.svg": "39f2",
	"./THA.svg": "8c9b",
	"./TJK.svg": "c408",
	"./TKL.svg": "85e8",
	"./TKM.svg": "8341",
	"./TLS.svg": "6655",
	"./TON.svg": "d034",
	"./TTO.svg": "271c",
	"./TUN.svg": "5056",
	"./TUR.svg": "9973",
	"./TUV.svg": "7150",
	"./TWN.svg": "932e",
	"./TZA.svg": "6843",
	"./UGA.svg": "c60f",
	"./UKR.svg": "5425",
	"./UMI.svg": "60d5",
	"./URY.svg": "71b9",
	"./USA.svg": "21f5",
	"./UZB.svg": "278e",
	"./VAT.svg": "a84f",
	"./VCT.svg": "d7b2",
	"./VEN.svg": "705c",
	"./VGB.svg": "674b",
	"./VIR.svg": "58b7",
	"./VNM.svg": "7e10",
	"./VUT.svg": "fd67",
	"./WLF.svg": "06c3",
	"./WSM.svg": "9589",
	"./XKX.svg": "7e26",
	"./YEM.svg": "51fa",
	"./ZAF.svg": "3f63",
	"./ZMB.svg": "b0d5",
	"./ZWE.svg": "90fe",
	"./unknown.svg": "fded",
	"./world.svg": "e30a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc3b";